import React, { useState, useEffect } from 'react';
import { createClass, fetchTerms, fetchLevels } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';

const CreateClassModal = ({ onClose, onClassCreated }) => {
    const [terms, setTerms] = useState([]);
    const [levels, setLevels] = useState([]);
    const [selectedTerm, setSelectedTerm] = useState('');
    const [selectedLevel, setSelectedLevel] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const termsData = await fetchTerms();
                setTerms(termsData.data);
                const levelsData = await fetchLevels();
                setLevels(levelsData.data);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        };
        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);
        try {
            await createClass({ term_id: parseInt(selectedTerm), level_id: parseInt(selectedLevel) });
            setSuccess('Class created successfully!');
            onClassCreated();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Create Class</h2>
                {error && <div className="error-message">{error}</div>}
                {success && <div className="success-message">{success}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <select value={selectedTerm} onChange={(e) => setSelectedTerm(e.target.value)} required>
                            <option value="">Select Term</option>
                            {terms.map(term => (
                                <option key={term.id} value={term.id}>{term.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <select value={selectedLevel} onChange={(e) => setSelectedLevel(e.target.value)} required>
                            <option value="">Select Level</option>
                            {levels.map(level => (
                                <option key={level.id} value={level.id}>{level.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="actions-centered">
                        <button type="button" className="cancel-button text-button" onClick={onClose}>Cancel</button>
                        <button type="submit" className="submit-button text-button">Create</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateClassModal;